export class Destinatario {
  nombre: string;
  puesto: string;
}
